module.exports = __webpack_public_path__ + "fonts/GOTHICB.ae704b11.TTF";